import { render, staticRenderFns } from "./ExportarPreguntas.vue?vue&type=template&id=2df592e5"
import script from "./ExportarPreguntas.vue?vue&type=script&lang=js"
export * from "./ExportarPreguntas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports